import React, { useContext, useEffect, useRef, useState } from 'react';
import AuthContext from '../../authentication/AuthContext';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { IconWrapper } from '../IconWrapper';

export default function CategoryFilter({
    supplierCode,
    selectedSuperCategory,
    selectedCategory,
    categoryChanged,
    superCategoryChanged,
    upIcon,
    downIcon
}) {
    const [categories, setCategories] = useState([]);
    const [currentCategory, setCurrentCategory] = useState(selectedSuperCategory);
    const [showCategories, setShowCategories] = useState(false);
    const [spacers, setSpacers] = useState([]);

    const cas = useContext(AuthContext);

    const ref = useRef(null);

    useEffect(() => {
        axios
            .get(
                window.CONFIG['ws.activoc-web-order-api.categories.suppliercategories.full'].replace(
                    '{supplierCode}',
                    supplierCode
                ),
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                let json = response.data;
                setCategories(
                    json
                        .sort((a, b) => a - b)
                        .map(superCategory => {
                            let subCategories = superCategory.categories.map(category => (
                                <button
                                    onClick={() => {
                                        categoryChanged(category);
                                        setCurrentCategory(category);
                                        setShowCategories(false);
                                    }}
                                    key={category}
                                    className={'category-name'}
                                >
                                    {category}
                                </button>
                            ));
                            return (
                                <div key={superCategory.superCategory} className={'super-category'}>
                                    <button
                                        onClick={() => {
                                            superCategoryChanged(superCategory.superCategory);
                                            setCurrentCategory(superCategory.superCategory);
                                            setShowCategories(false);
                                        }}
                                        className={'super-category-name'}
                                    >
                                        {superCategory.superCategory}
                                    </button>
                                    <div>{subCategories}</div>
                                </div>
                            );
                        })
                );
            });
        // eslint-disable-next-line
    }, [cas, supplierCode]);

    useEffect(() => {
        selectedCategory !== ''
            ? setCurrentCategory(selectedCategory)
            : setCurrentCategory(selectedSuperCategory);
    }, [selectedCategory, selectedSuperCategory]);

    useEffect(() => {
        let spacerList = [];
        let numberOfSpacers = 5;
        if (categories.length < 6) {
            numberOfSpacers = categories.length - 1;
        }
        for (let i = 0; i < numberOfSpacers; i++) {
            spacerList.push(<div className={'super-category'} key={i} data-testid={'spacer-' + i} />);
        }
        setSpacers(spacerList);
    }, [categories]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowCategories(false);
            }
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);

    return (
        <div id={'category-filter'} ref={ref}>
            <Button className={'dropdown-trigger'} onClick={() => setShowCategories(!showCategories)}>
                <span className={'current-category'}>{currentCategory}</span>
                <IconWrapper icon={showCategories ? upIcon : downIcon} />
            </Button>
            {showCategories ? (
                <div
                    className={'all-categories flex'}
                    style={{
                        width: categories.length >= 6 ? '1200px' : categories.length * 200 + 'px'
                    }}
                >
                    <div className={'super-category'}>
                        <button
                            onClick={() => {
                                superCategoryChanged('All Categories');
                                setCurrentCategory('All Categories');
                                setShowCategories(false);
                            }}
                            className={'super-category-name'}
                        >
                            All Categories
                        </button>
                    </div>
                    {spacers}
                    {categories}
                </div>
            ) : null}
        </div>
    );
}
